import { z } from 'zod';
import { homepageLayoutSchema } from './homepage';

// Same slug ruleset as group-content + posts.
const slugRx = /^[฀-๿a-z0-9]+(?:-[฀-๿a-z0-9]+)*$/u;

const slugSchema = z
  .string()
  .trim()
  .min(1, 'กรุณาใส่ slug')
  .max(80)
  .regex(slugRx, 'slug ใช้ได้: ไทย / a-z / 0-9 และ - เท่านั้น');

const nameSchema = z.string().trim().min(1, 'กรุณาใส่ชื่อ').max(120);

const descriptionSchema = z
  .string()
  .trim()
  .max(500)
  .nullable()
  .transform((v) => (v === '' || v === null ? null : v));

export const createPageSchema = z.object({
  name: nameSchema,
  /** Auto-generated from name when omitted. */
  slug: slugSchema.optional(),
  description: descriptionSchema.optional(),
  /** Optional starting layout — omit for empty slots[]. */
  layout: homepageLayoutSchema.optional(),
});

export type CreatePageInput = z.infer<typeof createPageSchema>;

export const updatePageSchema = z.object({
  name: nameSchema.optional(),
  /** Slug rename — blocked at the route level for `is_system` pages. */
  slug: slugSchema.optional(),
  description: descriptionSchema.optional(),
  layout: homepageLayoutSchema.optional(),
});

export type UpdatePageInput = z.infer<typeof updatePageSchema>;

export const listPagesQuerySchema = z.object({
  q: z.string().trim().max(80).optional(),
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(20),
});

export type ListPagesQuery = z.infer<typeof listPagesQuerySchema>;

export const pageSlugCheckSchema = z.object({
  slug: slugSchema,
  excludeId: z.string().min(1).optional(),
});

export type PageSlugCheck = z.infer<typeof pageSlugCheckSchema>;
